import { render, staticRenderFns } from "./TabelaFornecedoresJuridicos.vue?vue&type=template&id=32c7379e&scoped=true"
import script from "./TabelaFornecedoresJuridicos.vue?vue&type=script&lang=js"
export * from "./TabelaFornecedoresJuridicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c7379e",
  null
  
)

export default component.exports